import styled, { css } from 'styled-components';
import { UniversalPicker } from '@rainbow-modules/forms';
import { PURPLE_500, DIVIDER } from '../../constants';
import { ChannelType } from './types';

const getColorForChannel = (channel: ChannelType) => {
    if (channel === 'facebook') return '#1877F2';
    if (channel === 'instagram') return '#DD2A7B';
    if (channel === 'whatsapp') return '#25D366';
    if (channel === 'widget_chatbot') return '#2E2960';
    if (channel === 'tiktok') return '#000000';
    if (channel === 'telegram') return '#24A1DE';
    return PURPLE_500;
};

export const StyledUniversalPicker = styled(UniversalPicker)`
    legend {
        padding-left: 0;
    }

    legend + div {
        justify-content: flex-start;
    }

    label, label > div {
        height: 100%;
    }
`;

export const PickerOptionContainer = styled.div<{
    isSelected?: boolean; disabled?: boolean; isHover?: boolean; channel: ChannelType;
    isIconOnly?: boolean;
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 2rem;
    padding: 0.5rem;
    gap: 0.5rem;
    border: 1px solid ${DIVIDER};
    border-radius: 0.25rem;
    white-space: nowrap;
    flex-shrink: 0;
    min-width: fit-content;
    
    /* Icon styling */
    & > span {
        display: flex;
        align-items: center;
        justify-content: center;
        
        & > svg {
            width: 1rem;
            height: 1rem;
        }
    }
    
    /* Text styling - match icon visual size */
    & > span:last-child {
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 1;
    }
    
    /* Icon-only mode - center everything */
    ${(props) => props.isIconOnly && css`
        justify-content: center;
        padding: 0.5rem;
    `}

    ${(props) => props.isHover && !props.disabled && css`
        border-color: ${getColorForChannel(props.channel)};
        background: ${getColorForChannel(props.channel)};
        color: white;
        cursor: pointer;
    `};

    ${(props) => props.isSelected && css`
        border-color: ${getColorForChannel(props.channel)};
        background: ${getColorForChannel(props.channel)};
        color: white;
    `};
`;
